import React, { useState } from "react";
import "./PostCard.css";
import { Button } from "./Button";

type Props = {
  title: string;
  excerpt: string;
  meta: string;
  time: string;
};

export function PostCard({ title, excerpt, meta, time }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <article className="postCard">
      <div className="postMetaRow">
        <span className="postMeta">{meta}</span>
        <span className="postTime">{time}</span>
      </div>

      <h3 className="postTitle">{title}</h3>
      <p className="postExcerpt">{excerpt}</p>

      <div className="postActions">
        <Button variant={open ? "secondary" : "ghost"} size="sm" onClick={() => setOpen((v) => !v)}>
          {open ? "Свернуть" : "Открыть"}
        </Button>
      </div>

      <div className={`postMore ${open ? "postMoreOpen" : ""}`} aria-hidden={!open}>
        <div className="postMoreInner">
          <div className="postDivider" />
          <p className="postMoreText">
            Это демо-страница. Если вы хотите, я добавлю полноценный блог с маршрутами, страницами постов и
            админкой/Markdown — просто скажите.
          </p>
          <div className="postChips">
            <span className="chip">честно</span>
            <span className="chip">коротко</span>
            <span className="chip">по делу</span>
          </div>
        </div>
      </div>
    </article>
  );
}